"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var Modal_1 = __importDefault(require("components/modal/Modal"));
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/Notification");
var add_icon_svg_1 = __importDefault(require("res/img/add-icon.svg"));
var ProductOptionForm_1 = __importDefault(require("./ProductOptionForm"));
var apiRoutes = config_1.default.apiRoutes;
var CreateProductOption = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = react_1.useState(false), success = _b[0], setSuccess = _b[1];
    var _c = use_stores_1.useStores(), apiStore = _c.apiStore, productOptionsStore = _c.productOptionsStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var successTimerRef = react_1.useRef(null);
    var history = react_router_dom_1.useHistory();
    var notification = use_notification_1.useNotification();
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function () {
        if (!data.name || data.name.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Please enter a name'
            });
            return;
        }
        api_1.default.createProductOption(data)
            .then(function (response) {
            productOptionsStore.addDataItem(response.data);
            setSuccess(true);
            clearTimeout(successTimerRef.current);
            successTimerRef.current = setTimeout(function () {
                setSuccess(false);
                history.replace('/products/options');
            }, 1500);
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement(Modal_1.default, { title: [
            react_1.default.createElement("img", { key: "cp_title_1", src: add_icon_svg_1.default, alt: 'Create' }),
            react_1.default.createElement("span", { key: "cp_title_2" }, "Create a Product Option")
        ] },
        react_1.default.createElement("div", { className: 'create-product-option create-modal' },
            react_1.default.createElement(ProductOptionForm_1.default, { data: data, onChange: changeHandler, onSubmit: submitHandler, busy: busyRoutes.includes(apiRoutes.PRODUCT_OPTIONS), success: success }))));
});
exports.default = CreateProductOption;
